import { TTourStep } from "@amphore-dev/amphore-lib";
import { t } from "i18next";

/**
 * The tour after the onboarding (issue #74), on the home page: a welcome
 * step, then four targets. One list for desktop and mobile: the sidebar
 * and the bottom nav bar are never on screen together, nor the two "new
 * task" buttons, so each pair shares its `data-tour` (the menu's wording
 * differs by device).
 *
 * A function, not a constant: `t()` has to run once i18next is ready,
 * and again when the language changes.
 */
export const getIntroTourSteps = (): TTourStep[] => [
	// No target: centered. Out of the count, so the tour proper reads
	// "1 of 4". "Later" is the skip button: recorded as skipped, the
	// profile replays it.
	{
		title: t("tour.intro.welcome.title"),
		content: (
			<div className="mb-4!">
				<div
					style={{
						textAlign: "center",
						height: "max(10vh, 200px)",
						backgroundImage:
							"url('/assets/illustrations/idle.svg')",
						backgroundSize: "contain",
						backgroundPosition: "center",
						backgroundRepeat: "no-repeat",
					}}
				/>
				{t("tour.intro.welcome.content")}
			</div>
		),
		nextLabel: t("tour.intro.welcome.start"),
		skipLabel: t("tour.intro.welcome.later"),
		progress: false,
		actionsAlign: "center",
		style: {
			textAlign: "center",
		},
	},
	{
		target: '[data-tour="menu"]',
		title: t("tour.intro.menu.title"),
		content: {
			desktop: t("tour.intro.menu.desktop"),
			mobile: t("tour.intro.menu.mobile"),
		},
		placement: "right-start",
	},
	{
		target: '[data-tour="view"]',
		title: t("tour.intro.view.title"),
		content: t("tour.intro.view.content"),
		placement: "bottom-start",
	},
	{
		target: '[data-tour="calendar"]',
		title: t("tour.intro.calendar.title"),
		content: t("tour.intro.calendar.content"),
		placement: "bottom",
	},
	{
		target: '[data-tour="new-task"]',
		title: t("tour.intro.newTask.title"),
		content: t("tour.intro.newTask.content"),
		placement: "bottom-end",
		// Hidden where the person cannot create (a view they only read).
		optional: true,
	},
];
